export function ensureURL(rawURL) {
  if (rawURL.endsWith('/')) {
    return rawURL.slice(0, -1);
  }

  return rawURL;
}
